import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'mockup',
});

export const managementRouteRef = createRouteRef({
  id: 'mockup-management',
});

export const previewRouteRef = createRouteRef({
  id: 'mockup-preview',
  params: ['mockupName'],
});
